import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HOST, INDICADORES_CHV, INDICADORES_CALENDARIO_TRIMESTRES_FIVI, INDICADORES_TRIMESTRAL_FIVI, INDICADORES_MENSUAL_FIVI } from 'src/app/global';
import { InforIndicadoresDtoI } from 'src/app/modelos/InformacionIndicadoresDto';
import { PeriodoTrimestralesFiviDto } from 'src/app/modelos/PeriodosTrimestralesFivi';

@Injectable({
  providedIn: 'root'
})
export class IndicadoresService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }

InformacionIndicadoresChv(idPeriodo):Observable<InforIndicadoresDtoI>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + INDICADORES_CHV + idPeriodo;
  return this.http.get<InforIndicadoresDtoI>(direccion, {'headers': header});
}

CalendarioTrimestresFivi():Observable<PeriodoTrimestralesFiviDto[]>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + INDICADORES_CALENDARIO_TRIMESTRES_FIVI;
  return this.http.get<PeriodoTrimestralesFiviDto[]>(direccion, {'headers': header});
}

InformacionIndicadoresFivi(trimestre):Observable<InforIndicadoresDtoI>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + INDICADORES_TRIMESTRAL_FIVI + trimestre;
  return this.http.get<InforIndicadoresDtoI>(direccion, {'headers': header});
}

InformacionIndicadoresMensualesFivi(periodo):Observable<InforIndicadoresDtoI>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + INDICADORES_MENSUAL_FIVI + periodo;
  return this.http.get<InforIndicadoresDtoI>(direccion, {'headers': header});
}

}
